import React from 'react';

import { dataHooks } from '../../constants';
import { FieldSetProps, LegendSize } from '../../FieldSet.types';
import InfoIconBase from '../../../InfoIcon';

import { st, classes } from './InfoContentIcon.st.css';

type Props = Pick<
  FieldSetProps,
  'infoContent' | 'infoTooltipProps' | 'required'
> & {
  labelSize: LegendSize;
};

const InfoContentIcon = ({
  infoContent,
  infoTooltipProps,
  required,
  labelSize,
}: Props) => {
  return infoContent ? (
    <InfoIconBase
      dataHook={dataHooks.infoIcon}
      className={st(classes.root, {
        labelSize,
        required,
      })}
      content={infoContent}
      tooltipProps={infoTooltipProps}
      size="small"
    />
  ) : null;
};

export default InfoContentIcon;
